import React from "react";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import timeSetter from "../../utils/timeSetter";
import Typography from "../Typography/Typography";
import { ChatRightStyle } from "./ChatRightStyle";

const ChatRight = ({ data, APIChat }) => {
  return (
    <ChatRightStyle>
      <div className="user d-flex">
        <img
          src={`https://apisalamat.mahanskinclinic.com/thumbnail/Profile/${
            !APIChat ? data?.user?.Image : APIChat?.user_writer?.Image
          }`}
          alt=""
          className="rounded-circle"
        />
        <Typography
          size="14px"
          weight="bold"
          className="me-2 ms-3 d-flex align-items-center"
        >
          {!APIChat
            ? (data?.user?.FirstName ? data?.user?.FirstName : "") +
              " " +
              (data?.user?.LastName ? data?.user?.LastName : "")
            : (APIChat?.user_writer?.FirstName
                ? APIChat?.user_writer?.FirstName
                : "") +
              " " +
              (APIChat?.user_writer?.LastName
                ? APIChat?.user_writer?.LastName
                : "")}
        </Typography>
        <Typography
          size="12px"
          className="d-flex align-items-center"
          primary="#b2b5c4"
        >
          {!APIChat
            ? MiladiToShamsi(data?.created_at) +
              " " +
              timeSetter(data?.created_at)
            : MiladiToShamsi(APIChat?.CluckChat) +
              " " +
              timeSetter(APIChat?.CluckChat)}
        </Typography>
      </div>
      <div className="text">
        <Typography pre>
          {!APIChat ? (
            <div dangerouslySetInnerHTML={{ __html: data?.content }}></div>
          ) : (
            APIChat?.TextChat
          )}{" "}
          {!APIChat ? (
            data?.files.length ? (
              <a
                className="link"
                href={`https://apisalamat.mahanskinclinic.com/thumbnail/Ticket/${data?.files[0]?.TitleFile}`}
                target="_blank"
              >
                فایل ضمیمه شده
              </a>
            ) : (
              ""
            )
          ) : APIChat?.files?.length ? (
            <a
              className="link"
              href={`https://apisalamat.mahanskinclinic.com/thumbnail/ChatOnline/${APIChat?.files[0]?.TitleFile}`}
              target="_blank"
            >
              فایل ضمیمه شده
            </a>
          ) : (
            ""
          )}
        </Typography>
      </div>
    </ChatRightStyle>
  );
};

export default ChatRight;
